export enum IngredientCategory {
    Fruits = 'Fruits',
    Vegetables = 'Vegetables',
    BreadAndBakery = 'Bread & bakery Products',
    DairyAndEggs = 'Dairy & Eggs',
    Meat = 'Meat',
    FishAndSeafood = 'Fish & Seafood',
    FrozenFood = 'Frozen Food',
    OilVinegarSauces = 'Oil, Vinegar & Sauces',
    SpreadAndDips = 'Spread & Dips',
    HerbsAndSpices = 'Herbs & Spices',
    Baking = 'Baking',
    PastaAndRice = 'Pasta & Rice',
    DriedFruitsAndNuts = 'Dried Fruits & Nuts',
    ReadyMeals = 'Ready Meals',
    DairyAlternatives = 'Dairy Alternatives',
    CannedGoods = 'Canned Goods',
    Cereals = 'Cereals',
    SweetsAndSnacks = 'Sweets & Snacks',
    Beverages = 'Beverages'
  }
  